<template>
  <section class="bgFotoFolien">
    <div class="row justify-content-center m-md-2">
      <div class="col-lg-8 text-center headline">
        <h1 class="headline">Folien</h1>
      </div>
    </div>
    <div class="row justify-content-center p-2 m-md-2">
      <div class="col-lg-6 DES bildschirnansicht text-center">
        <h2 class="headline2 p-4 m-md-5">
          Wir stehen für Qualität, Präzision und individuelle Lösungen.
        </h2>
      </div>
    </div>

    <div class="row justify-content-center p-2 m-md-2">
      <div class="col-lg-6 DES bildschirnansicht text-center">
        <h3 class="headline2 p-4 m-md-5">
          Handstretchfolie, Maschinenstretchfolie,
          <br />
          <br />
          Luftpolsterfolie
        </h3>
      </div>
    </div>
  </section>
  <section>
    <div>
      <div class="row justify-content-center m-0 hellgrauHintergrund">
        <div class="col-lg-8 text-center">
          <h2 class="headline2 mt-5">Flexibel, effizient und passgenau:</h2>
          <h5 class="headline3">
            Unsere Verpackungsfolien schützen Ihre Produkte zuverlässig vor Feuchtigkeit,
            Staub und Beschädigungen.<br/> Ob beim Transport oder bei der Lagerung – auf unsere
            Qualität können Sie sich verlassen.
          </h5>
        </div>
      </div>
    </div>
  </section>
  <section>
    <balkenMitBild />
  </section>

  <stickybarTelMail />
  <stickyPfeil />
</template>

<script>
import stickyPfeil from "../components/stickyPfeil.vue";
import stickybarTelMail from "../components/stickybarTelMail.vue";
import balkenMitBild from "../components/balkenMitBildFolien.vue";

export default {
  name: "ImpressumPage",

  data() {
    return {
      newSite: null,
    };
  },
  components: {
    stickyPfeil,
    stickybarTelMail,
    balkenMitBild,
  },
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
